/* eslint-disable react-hooks/exhaustive-deps */
import { Navigate, Outlet } from 'react-router-dom';
import { getUserDetails } from '../utils/orgName';
import moment from 'moment';
import { useLogout } from '../hooks';
import { useAppSelector } from '../redux/hooks';

import ROLES from '../utils/roles';
import useProfileDetails from '../hooks/useProfileDetails';
import _ from 'lodash';
import useOrgSettings from '../hooks/useOrgSettings';
import { isLoggingOut } from '../utils/logoutInProgress';
import { isCandidateRoute, useHiringCandidateLanding } from './HiringCandidateRedirect';

const SecuredRoutes = () => {
  const tokens = localStorage.getItem('tokens');
  const isLoggedIn = localStorage.getItem('isAuthenticated') || false;
  const { doLogout } = useLogout();
  const role = localStorage.getItem('role');
  const { exp } = getUserDetails();
  const currentTime = moment();
  const expiryTime = moment.unix(exp);
  const userData = useAppSelector((state) => state.userProfile.data);
  const { ftue, firstName } = useProfileDetails();
  const isOrgSettings = useOrgSettings();
  const candidate = useHiringCandidateLanding();

  const checkSession = () => {
    if (currentTime.isAfter(expiryTime)) {
      doLogout();
      return null; // Return null since the navigation will handle the rendering
    } else {
      if (userData && ftue && role !== ROLES.platAdmin) {
        if (role === ROLES.orgAdmin && !isOrgSettings && firstName !== '') {
          return <Outlet />;
        }
        // A Hiring candidate never goes through the member first-time setup
        // (DA-5042 C-9): it is a learner view, and it would ask them for
        // attributes and a member type, which is what makes someone look like
        // a member. Their own onboarding is the round's. Routes/Redirect.tsx
        // sends them here, so bouncing them away would loop.
        if (candidate === 'candidate' || isCandidateRoute()) return <Outlet />;
        if (candidate === 'asking') return null;
        window.location.replace('/');
        return null;
      }
      return <Outlet />; // Render the nested routes
    }
  };
  // On the way out to Auth0 the storage is already empty: sending the user to /login now would start a
  // new sign-in and cancel the logout (utils/logoutInProgress.ts).
  if (isLoggingOut()) return null;
  return role && (tokens || isLoggedIn) ? checkSession() : <Navigate to="/login" />;
};

export default SecuredRoutes;
